import PropTypes from 'prop-types';
import React from 'react';

function Play(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_21673_235640)">
        <path
          d="M3.2771 4.10443V19.8956C3.27708 20.1297 3.33776 20.3599 3.45323 20.5636C3.5687 20.7673 3.73501 20.9375 3.93592 21.0578C4.13684 21.178 4.3655 21.2441 4.59958 21.2496C4.83366 21.2551 5.06517 21.1998 5.2715 21.0892L20.0088 13.1936C20.2247 13.0778 20.4051 12.9057 20.5309 12.6955C20.6567 12.4853 20.7232 12.245 20.7232 12C20.7232 11.755 20.6567 11.5147 20.5309 11.3045C20.4051 11.0943 20.2247 10.9222 20.0088 10.8064L5.2715 2.91084C5.06517 2.80016 4.83366 2.74487 4.59958 2.75037C4.3655 2.75587 4.13684 2.82197 3.93592 2.94221C3.73501 3.06245 3.5687 3.23273 3.45323 3.43643C3.33776 3.64012 3.27708 3.87028 3.2771 4.10443Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_21673_235640">
          <rect fill="white" height="24" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
}

Play.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Play;
